import { createAction } from '@ngrx/store';

export namespace ModalsActions {
  export const dismissAll = createAction('[Modals] Dismiss All Opened Modals');
}
